<div
   class="tw-bg-black tw-overflow-hidden transition-all duration-300"
   [ngClass]="{
    'tw-relative tw-rounded-3': !isFullScreen,
    'tw-fixed tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-z-[110]': isFullScreen
  }">
   <video class="tw-h-full tw-w-full" #myvideo playsinline autoplay muted loop preload="auto" crossorigin="anonymous"
      (error)="onVideoError($event)" (loadedmetadata)="onMetadataLoaded(myvideo)" (click)="toggleFullScreen()">
        <source [src]="url()" type="video/mp4">
         Your browser does not support the video tag.
   </video>

   <div
      class="tw-absolute tw-top-1 tw-h-7 tw-w-7 tw-rounded-full tw-bg-white/40 tw-backdrop-blur-lg tw-flex tw-items-center tw-justify-center"
      [ngClass]="{
         'tw-top-1 tw-left-1': !isFullScreen,
         'tw-top-4 tw-left-4': isFullScreen,
      }" (click)="toggleMute(myvideo); $event.stopPropagation()">
      @if (myvideo.muted) {
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'no_sound'"></cs-icon>
      }
      @if (!myvideo.muted) {
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'volume_up'"></cs-icon>
      }
   </div>
   <div
      class="tw-absolute tw-top-4 tw-h-7 tw-w-7 tw-rounded-full tw-bg-white/40 tw-backdrop-blur-lg tw-flex tw-items-center tw-justify-center"
      [ngClass]="{
         'tw-top-1 tw-right-1': !isFullScreen,
         'tw-top-4 tw-right-4': isFullScreen,
      }"
      (click)="toggleFullScreen(); $event.stopPropagation()">
      @if (isFullScreen) {
         <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'close'"></cs-icon>  
      } @else {
         <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'open_in_full'"></cs-icon>
      }
   </div>
</div>